import React from 'react';
import Style from './twigError.module.css';
import { useTranslation } from 'react-i18next';

import { Message } from '@weezevent/nacre';

export default function TwigError({ codeTwigErrors }) {
    const { t } = useTranslation();

    return (
        <div id="error-container">
            {codeTwigErrors?.length > 0 && (
                <div id={Style['error-wrapping-box']}>
                    <Message type="danger" title="Twig errors">
                        {codeTwigErrors.map((error, index) => (
                            <span key={index}>
                                <div>
                                    <span>{t('ticket.ticket_design.templates.twig_error.error')}</span>
                                    <span className={Style['error-code']}>{error.error}</span>
                                    <span>{t('ticket.ticket_design.templates.twig_error.content')}</span>
                                    <span className={Style['error-code']}>{error.content}</span>
                                    <span>{t('ticket.ticket_design.templates.twig_error.type')}</span>
                                    <span className={Style['error-code']}>{error.element}</span>
                                </div>
                            </span>
                        ))}
                    </Message>
                </div>
            )}
        </div>
    );
}
